import { render, staticRenderFns } from "./BankCardTypePicker.vue?vue&type=template&id=b5a1358a&"
import script from "./BankCardTypePicker.vue?vue&type=script&lang=js&"
export * from "./BankCardTypePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports